import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { scrubURL } from './components/routes/App/App';
import { router } from './router';
import '../i18n/i18n';
import * as Sentry from '@sentry/react';

if (import.meta.env.MODE === 'production') {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		release: import.meta.env.VITE_APP_VERSION || 'dev',
		integrations: [],
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		beforeSend(event) {
			if (event.request && event.request.url) {
				event.request.url = scrubURL(event.request.url);
			}
			return event;
		},
	});
}

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>,
);
